<template>
  <div class="step-otp">
    <!-- Back button -->
    <div class="mb-4">
      <a href="javascript:void(0)" class="btn-back" @click="prevStep">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="me-1"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Quay lại
      </a>
    </div>

    <div class="text-center mb-3">
      <div class="otp-icon-wrapper mx-auto mb-3">
        <img src="@/assets/img/nganluong/icon-otp.svg" alt="OTP" />
      </div>
      <h2 class="otp-title fw-bold text-uppercase mb-2">Xác thực bảo mật</h2>
      <p class="otp-desc mb-0 text-center">
        Mã xác thực (OTP) đã được gửi đến {{ sendToText }}<br />
        <strong class="text-dark">{{ sendToValue }}</strong>
      </p>
    </div>

    <!-- OTP inputs -->
    <div :class="['otp-group mt-4', { 'otp-group-erross': !!messageError }]">
      <input
        v-for="(digit, index) in 6"
        :key="index"
        type="number"
        class="otp-input form-control"
        maxlength="1"
        max="9"
        min="0"
        v-model="otp[index]"
        @input="handleInput($event, index)"
        @keydown="handleKeydown($event, index)"
        @paste.prevent="handlePaste($event)"
        :ref="'otpInput' + index"
      />
    </div>
    <p v-if="messageError" class="text-danger text-center mt-2" style="font-size: 14px">
      {{ messageError }}
    </p>

    <!-- Countdown / Resend -->
    <div class="text-center countdown-text mt-3">
      <template v-if="timeLeft > 0">
        Mã hết hạn sau: <span class="countdown-time">{{ formattedTime }}</span>
      </template>
      <template v-else>
        Mã đã hết hạn.
        <a href="javascript:void(0)" class="resend-link" @click="resendOtp">Gửi lại mã</a>
      </template>
    </div>

    <!-- Fake footer -->
    <div class="popup-footer">
      <b-button variant="primary" class="footer-btn" :disabled="!isFullOtp" @click="verifyOtp">
        Hoàn tất xác thực
      </b-button>
    </div>
  </div>
</template>

<script>
  import {
    appendixContractNlActionRemoteOTP,
    appendixContractNlGetOTP,
  } from '@/services/contract.service'

  const OTP_EXPIRE_SECONDS = 5 * 60 // 5 phút

  export default {
    name: 'StepOtp',
    props: {
      id: { type: String, required: true },
      mobile: { type: String, default: '' },
      method: { type: String, default: '' },
      signature: { type: String, default: '' },
      token: { type: String, required: true },
      updateShowLoading: { type: Function, required: true },
    },
    data() {
      return {
        otp: ['', '', '', '', '', ''],
        timeLeft: OTP_EXPIRE_SECONDS,
        timer: null,
        messageError: '',
      }
    },
    mounted() {
      this.startTimer()
      this.$nextTick(() => {
        if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
          this.$refs.otpInput0[0].focus()
        }
      })
    },
    // watch: {
    //   step: {
    //     immediate: true,
    //     handler(val) {
    //       if (val === 3) {
    //         this.startTimer()
    //         this.$nextTick(() => {
    //           if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
    //             this.$refs.otpInput0[0].focus()
    //           }
    //         })
    //       }
    //     },
    //   },
    // },
    computed: {
      sendToText() {
        const map = {
          EMAIL: 'email',
          SMS: 'số',
          ZNS: 'tin nhắn Zalo số',
        }
        return map[this.method] || ''
      },
      sendToValue() {
        if (this.method === 'EMAIL') {
          return this.$options.filters.maskEmail(this.email)
        }
        return this.$options.filters.maskPhone(this.mobile)
      },
      isFullOtp() {
        return this.otp.every(d => d !== '')
      },
      formattedTime() {
        const mins = Math.floor(this.timeLeft / 60)
          .toString()
          .padStart(2, '0')
        const secs = (this.timeLeft % 60).toString().padStart(2, '0')
        return `${mins}:${secs}`
      },
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      prevStep() {
        clearInterval(this.timer)
        this.$emit('prev-step')
      },
      startTimer() {
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          if (this.timeLeft > 0) this.timeLeft--
          else clearInterval(this.timer)
        }, 1000)
      },
      resetTimer() {
        this.timeLeft = OTP_EXPIRE_SECONDS
        this.otp = ['', '', '', '', '', '']
        this.messageError = ''
        this.startTimer()
        this.$nextTick(() => {
          if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
            this.$refs.otpInput0[0].focus()
          }
        })
      },
      handleInput(e, index) {
        const val = e.target.value.replace(/[^0-9]/g, '').slice(-1)
        e.target.value = val
        this.$set(this.otp, index, val)
        if (val !== '' && index < 5) {
          this.$refs['otpInput' + (index + 1)][0].focus()
        }
      },
      handleKeydown(e, index) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
          if (this.otp[index] === '' && index > 0) {
            this.$refs['otpInput' + (index - 1)][0].focus()
          }
          return
        }
        if (this.otp[index] !== '' && /^[0-9]$/.test(e.key)) {
          e.preventDefault()
        }
      },
      handlePaste(e) {
        const digits = (e.clipboardData.getData('text') || '')
          .replace(/[^0-9]/g, '')
          .slice(0, 6)
          .split('')
        digits.forEach((d, i) => this.$set(this.otp, i, d))
        const lastIndex = Math.min(digits.length, 5)
        this.$nextTick(() => {
          if (this.$refs['otpInput' + lastIndex]) {
            this.$refs['otpInput' + lastIndex][0].focus()
          }
        })
      },
      async verifyOtp() {
        try {
          this.messageError = ''
          this.updateShowLoading(true)
          // const res = await appendixContractNlConfirmOTP({
          //   id: this.id,
          //   otpCode: this.otp.join(''),
          //   type: 'TYPE_APPENDIX',
          //   isFromWeb: true,
          // })
          const res = await appendixContractNlActionRemoteOTP(
            {
              appendixId: this.id,
              otpCode: this.otp.join(''),
              signatures: [this.signature],
            },
            this.token
          )

          if (res.code === 1000) {
            this.$emit('next-step')
          } else {
            this.messageError = res.message ?? res.error
          }
        } catch (error) {
          this.messageError = error.response?.data?.message
            ? error.response.data.message
            : error.message
        } finally {
          this.updateShowLoading(false)
        }
      },
      async resendOtp() {
        try {
          this.updateShowLoading(true)
          const body = {
            id: this.id,
            type: 'TYPE_APPENDIX',
            isZns: this.selectedMethod === 'ZNS',
          }
          if (this.selectedMethod === 'EMAIL') {
            body.typeSend = this.selectedMethod
          }
          const res = await appendixContractNlGetOTP(body, this.token)
          if (res.code === 1000) {
            this.resetTimer()
          } else {
            this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(
            error.response?.data?.message ? error.response.data.message : error.message
          )
        } finally {
          this.updateShowLoading(false)
        }
      },
    },
  }
</script>

<style scoped>
  .step-otp {
    display: flex;
    flex-direction: column;
  }

  .btn-back {
    display: inline-flex;
    align-items: center;
    color: #555;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }

  .btn-back:hover {
    color: #0d6efd;
  }

  .otp-icon-wrapper {
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .otp-icon-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .otp-title {
    font-size: 18px;
    color: #222;
  }

  .otp-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }

  /* OTP inputs */
  .otp-group {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .otp-input {
    width: 46px !important;
    height: 52px !important;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    border: 2px solid #ddd;
    border-radius: 10px;
    padding: 0;
    -moz-appearance: textfield;
  }

  .otp-input::-webkit-outer-spin-button,
  .otp-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .otp-input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
    outline: none;
  }

  .otp-group-erross .otp-input {
    border-color: #dc3545;
    color: #dc3545;
    animation: shake 0.3s ease;
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-4px);
    }
    75% {
      transform: translateX(4px);
    }
  }

  .countdown-text {
    font-size: 14px;
    color: #666;
  }

  .countdown-time {
    font-weight: 700;
    color: #dc3545;
  }

  .resend-link {
    color: #0d6efd;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }

  /* Fake footer */
  .popup-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 0;
    border-top: 1px solid #e9ecef;
    margin-top: 24px;
  }

  .footer-btn {
    min-width: 160px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 20px;
  }
</style>
